const MS_PER_HOUR = 1000 * 60 * 60;

/**
 * Returns the duration of the historical range expressed in hours, treating the
 * selected lower/upper dates as whole calendar days.
 *
 * The number of days a user picks is a pure calendar concept: selecting the
 * 28th and the 30th is always "two days" regardless of where the user lives or
 * whether a daylight-saving-time transition happens in between. The arithmetic
 * is therefore done in UTC (which has no DST) so the result is always an exact
 * multiple of 24 — matching the calendar day that is later sent to the backend.
 */
export function getHistoricalRangeDurationHours(
  lower: Date,
  upper: Date,
): number {
  const startOfUtcDay = (date: Date): number =>
    Date.UTC(date.getFullYear(), date.getMonth(), date.getDate());

  return (startOfUtcDay(upper) - startOfUtcDay(lower)) / MS_PER_HOUR;
}

/**
 * Whether the chosen update interval divides evenly into the total duration of
 * the historical range.
 */
export function isUpdateIntervalDivisible(
  lower: Date,
  upper: Date,
  updateIntervalHours: number,
): boolean {
  return (
    getHistoricalRangeDurationHours(lower, upper) % updateIntervalHours === 0
  );
}
